define([
    'jquery',
    'mage/storage',
    'jquery/jquery-storageapi'
], function ($) {
    return {
        init() {
            this.initCache();
            this.initEvents();
        },

        initCache() {
            this.$lanSelect = $('#lanSelect');
            this.prevVal = this.$lanSelect.val();
        },

        initEvents() {
            this.$lanSelect.on('change', this.selectLan.bind(this));
        },

        selectLan(ev) {
            const $selectItem = $(ev.currentTarget);
            const pageUrl = $selectItem.val();
            const newStorViewLang = $selectItem.find('option:selected').text().trim().toUpperCase();

            $.cookieStorage.set('langCookie', newStorViewLang);

            this.$lanSelect.val(this.prevVal); // fix after back on browser

            window.location.assign(pageUrl)
        }
    }
})
